import React, { Component } from 'react'

class InputButton extends Component {
  render () {
    return (
      <div className={'input-group ' + (this.props.hidden ? 'hidden' : '')}>
        <input type='text' className='form-control' value={this.props.value || ''} readOnly />
        <span className='input-group-btn'>
          <button className='btn btn-primary' disabled={this.props.disabled} type='button' onClick={() => this.props.callback()}><i className={this.props.icon ? 'fa ' + this.props.icon : 'fa fa-folder-open'} /></button>
        </span>
      </div>
    )
  }
}
export default InputButton



// WEBPACK FOOTER //
// ./src/components/basic/misc/InputButton.js